<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @addNew="addNew"
      @handleCustomed="handlePrint"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          </div>
          <div class="queryItem">
            <label>报损单号:</label>
            <lk-input class="item" v-model.trim="query.breakageCode" :maxlength="50" clearable placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>报损时间:</label>
            <timeStampDatePicker type='daterange' class="item" clearable
              v-model.trim="query.duration" :options='approvalTimeOption'></timeStampDatePicker>
          </div>
          <div class="queryItem storeSelect">
            <label>商品仓库:</label>
            <lk-select class="item" v-model.trim="query.warehouseIds" placeholder="请选择" multiple>
              <lk-option v-for="item in warehouseData" :key="item.value" :value="item.value">
                {{item.label}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>供应商:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select class="item" v-model.trim="query.scrapStatus" placeholder="请选择" clearable>
              <lk-option v-for="(item,index) in approvalStatusMap" :key="index" :value="item[0]">
                {{item[1]}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select class="item" v-model="query.type" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>

          <div class="queryItem">
            <label>来源:</label>
            <lk-select class="item" v-model="query.purchaseType" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>批号:</label>
            <lk-input class="item" v-model.trim="query.batchCode" :maxlength="50" clearable placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btnContainer">
          <lk-button @click="addNew" icon='md-add' v-if="handlePermission('breakageAdd')" type='primary' >新建报损单</lk-button>
          <lk-button @click="handlePrint" v-if="handlePermission('breakagePrint')" type='primary' :disabled='selectedGoodsList.length === 0'>打印所选</lk-button>
         <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('breakageExcel')"></DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData" @on-selection-change='handleSelection'></lk-table>
      </div>
    </QueryFrame>
    <LinkQR033 ref="LinkQR033"></LinkQR033>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import LinkQR033 from '../../components/print/LinkQR033.vue';

import DownloadButton from '../../components/download/DownloadButton.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
// import supplier from '../../services/supplier';
// import permission from '../../mixins/permission'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

export default {
  name: 'breakageList',
  mixins: [queryMixins],
  components: {

    SupplierListSelect,
    QueryFrame,
    LinkQR033,
    DownloadButton,
  },
  data() {
    return {
      approvalTimeOption: this.approvalDate(),
      query: {
        storeIdList: [],
        nameMix: null,
        warehouseIds: null,
        supplierId: null,
        scrapStatus: null,
        type: null, // 商品类型
        purchaseType: null, // 来源
        batchCode: null, // 批号
        breakageCode: null, // 报损单号
        duration: [],
        breakageStartTime: null,
        breakageEndTime: null,
      },
      supplierList: [],
      selectedGoodsList: [],
      columns: [
        {
          title: '选择',
          key: 'id',
          type: 'selection',
          width: 80,
        },
        {
          title: '报损单号',
          key: 'breakageOrder',
          minWidth: 116,
        },
        {
          title: '商品编号',
          key: 'drugSerialCode',
          minWidth: 116,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '来源',
          key: 'purchaseType',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => {
            let purchaseTypeName = '';
            this.getGoodsOrigin.forEach((item) => {
              if (item.value === row.purchaseType) {
                purchaseTypeName = item.name;
              }
            });
            return h('span', purchaseTypeName);
          },
        },
        {
          title: '状态',
          key: 'scrapStatus',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 116,
        },
        {
          title: '商品仓库',
          key: 'warehouseName',
          minWidth: 116,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 116,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 116,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 116,
        },
        {
          title: '成本单价',
          key: 'priceWithTax',
          minWidth: 116,
        },
        {
          title: '有效期',
          key: 'expiryDate',
          minWidth: 116,
        },
        {
          title: '入库时间',
          key: 'purchaseDate',
          minWidth: 116,
        },
        {
          title: '报损人员',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '报损时间',
          key: 'scrapTime',
          minWidth: 116,
        },
        {
          title: '数量',
          key: 'scrapQuantity',
          fixed: 'right',
          width: 116,
        },
        {
          title: '报损金额',
          key: 'breakageTotalAmount',
          fixed: 'right',
          width: 116,
          render: (h, params) => h('span', (utils.toFixed2(params.row.breakageTotalAmount))),
        },
        {
          title: '不含税金额',
          key: 'priceWithoutTax',
          fixed: 'right',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '税金',
          key: 'tax',
          fixed: 'right',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', (utils.toFixed2(row.breakageTotalAmount - row.priceWithoutTax))),
        },
        {
          title: '报损原因',
          key: 'scrapReason',
          fixed: 'right',
          width: 116,
        },
      ],
      tableData: [],
      warehouseData: [],
      approvalStatusMap: new Map([
        [1, '已提交'],
        [2, '审批中'],
        [3, '已完成'],
        [4, '已拒绝'],
      ]),
    };
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
  },
  methods: {
    approvalDate() {
      return {
        disabledDate(time) {
          return time.getTime() > new Date();
        },
      };
    },
    handleSelection(selected) {
      console.log(selected);
      this.selectedGoodsList = selected;
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration.length >= 2) {
        this.params.breakageStartTime = this.params.duration[0];
        this.params.breakageEndTime = this.params.duration[1];
      }
      const tempParams = utils.deepClone(this.params);
      delete tempParams.duration;
      inventory.getBreakageData(tempParams).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((val) => {
            const result = {};
            utils.exchangeTable(val, result);
            result.scrapStatus = this.approvalStatusMap.get(result.scrapStatus);
            result.approvalStatus = this.approvalStatusMap.get(result.approvalStatus);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getWarehouseTable() {
      inventory.inventoryNameList().then((res) => {
        if (res.data.status === 200) {
          res.data.data.forEach((val) => {
            const result = {
              value: val.id,
              label: val.name,
            };

            this.warehouseData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'breakageAdd' });
    },
    handleReset() {
      this.query = {};
    },

    handlePrint() {
      const orderNoList = [...new Set(this.selectedGoodsList.map(item => item.breakageOrder))];
      if (orderNoList.length > 1) {
        this.$Message.error('请选择一张报损单打印');
        return;
      }
      this.$refs.LinkQR033.handlePrint(this.selectedGoodsList.map(item => item.id));
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      if (params.duration.length >= 2) {
        params.breakageStartTime = this.params.duration[0];
        params.breakageEndTime = this.params.duration[1];
      }
      const tempParams = utils.deepClone(params);
      delete tempParams.duration;
      inventory.ExportBreakage(tempParams).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch(true);
    this.getWarehouseTable();

    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>

<style lang="less" scoped>
.btnContainer{
  margin-bottom: 12px;
  margin-top:2px;
  >*{
    margin-right: 8px
  }

}
</style>
